// @ts-ignore
window.rootWindow = window;
